export default "__VITE_ASSET__BXg4NLCU__"